export enum TransactionTypeEnum {
  DEFAULT = 'default',
  FOREIGN = 'foreign'
}
